import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCompress } from '@fortawesome/sharp-light-svg-icons/faCompress';
import { faExpand } from '@fortawesome/sharp-light-svg-icons/faExpand';
import { faTimes } from '@fortawesome/sharp-light-svg-icons/faTimes';
import { faPlus } from '@fortawesome/sharp-light-svg-icons/faPlus';
import { faArrowUp } from '@fortawesome/sharp-light-svg-icons/faArrowUp';
import { faUser } from '@fortawesome/sharp-light-svg-icons/faUser';
import { faHeadset } from '@fortawesome/sharp-light-svg-icons/faHeadset';
import { faHistory } from '@fortawesome/sharp-light-svg-icons/faHistory';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faChevronDown } from '@fortawesome/sharp-light-svg-icons/faChevronDown';
import { faExclamationTriangle } from '@fortawesome/sharp-light-svg-icons/faExclamationTriangle';
import { faSearch } from '@fortawesome/sharp-light-svg-icons/faSearch';
import { faEdit } from '@fortawesome/sharp-light-svg-icons/faEdit';
import { faFile } from '@fortawesome/sharp-light-svg-icons/faFile';
import { faCommentMedical } from '@fortawesome/sharp-light-svg-icons/faCommentMedical';
import { faTrash } from '@fortawesome/sharp-light-svg-icons/faTrash';
import type { AiuiIcons, IconProps } from '@shipstation/aiui';

const createIcon =
  (icon: typeof faExpand) =>
  ({ size, color, className }: IconProps) => <FontAwesomeIcon className={className} color={color} fontSize={size} icon={icon} />;

/**
 * FontAwesome icons for AiChat component.
 * Using FA icons avoids bundling Tabler icons from aiui.
 */
export const aiChatIcons: AiuiIcons = {
  ExpandIcon: createIcon(faExpand),
  CollapseIcon: createIcon(faCompress),
  CloseIcon: createIcon(faTimes),
  PlusIcon: createIcon(faPlus),
  SendIcon: createIcon(faArrowUp),
  UserIcon: createIcon(faUser),
  AgentIcon: createIcon(faHeadset),
  HistoryIcon: createIcon(faHistory),
  LiveDotIcon: createIcon(faCircle),
  ChevronDownIcon: createIcon(faChevronDown),
  WarningIcon: createIcon(faExclamationTriangle),
  SearchIcon: createIcon(faSearch),
  FileIcon: createIcon(faFile),
  NewChatIcon: createIcon(faEdit),
  NewMessageIcon: createIcon(faCommentMedical),
  TrashIcon: createIcon(faTrash),
};
